<script context="module"></script>
<script>import { Metronome } from "../../../dsp/signal/metronome.js";
export let elem;
export let data;
export let probes;
let shortestInInterval = Object.keys(data.signals).flatMap(
  (feedId) => Object.values(data.signals[feedId]).map(
    (probeSignal) => probeSignal.interval()
  )
).reduce(
  (shortestInterval, signalInterval) => {
    return shortestInterval == void 0 ? signalInterval : Math.min(shortestInterval, signalInterval);
  },
  void 0
);
let metronome = void 0;
$: {
  metronome = shortestInInterval != void 0 && shortestInInterval > 0 && data.range.end > data.range.start ? new Metronome(data.range.start, data.range.end, shortestInInterval, false) : void 0;
}
const getProbeValue = (feedId, probeId, timestamp) => {
  const value = data.signals[feedId][probeId].get(
    timestamp
  );
  const precision = probes[probeId]?.precision;
  return value != void 0 && value != null ? precision != void 0 ? value.toFixed(precision) : value.toString() : "";
};
</script>

<div>
  <table bind:this={elem}>
    <thead>
      <tr>
        <th rowspan="2">UTC</th>
        {#each Object.keys(data.signals) as feedId}
          <th colspan={Object.keys(data.signals[feedId]).length}
            >{data.feeds[feedId] ? data.feeds[feedId].properties.label : feedId}</th
          >
        {/each}
      </tr>
      <tr>
        {#each Object.keys(data.signals) as feedId}
          {#each Object.keys(data.signals[feedId]) as probeId}
            <th>{`${probeId} (${data.signals[feedId][probeId].symbol()})`}</th>
          {/each}
        {/each}
      </tr>
    </thead>
    <tbody>
      {#if metronome != undefined}
        {#each metronome as timestamp}
          <tr>
            <td>{new Date(timestamp).toISOString()}</td>
            {#each Object.keys(data.signals) as feedId}
              {#each Object.keys(data.signals[feedId]) as probeId}
                <td>{getProbeValue(feedId, probeId, timestamp)}</td>
              {/each}
            {/each}
          </tr>
        {/each}
      {/if}
    </tbody>
  </table>
</div>

<style>
  table {
    border: 0;
    border-collapse: collapse;
    width: 100%;
  }

  .report table thead {
    background-color: var(--header-surface-color);
  }
  table thead tr th {
    font-weight: normal;
    text-align: unset;
  }
  table thead tr th {
    color: var(--header-onSurface-color);
  }
  table thead th {
    padding: 1em;
  }
  table tfoot td {
    padding: 1em;
  }
  table tbody td {
    padding: 0 1em 1em 1em;
  }
  table tbody tr td {
    color: var(--section-onSurface-color);
  }
</style>
